import { useQuery } from '@apollo/client';
import { contractBalancesQuery } from 'src/queries/contractBalancesQuery';

export enum ContractType {
  AD_PACK = 'AD_PACK',
  MASTER_AGREEMENT = 'MASTER_AGREEMENT',
  SEEK_CONTRACT = 'SEEK_CONTRACT',
  SUBSCRIPTION = 'SUBSCRIPTION',
}

export interface AdvertiserContract {
  contractType: ContractType;
}

interface ContractBalances {
  contractBalances: AdvertiserContract[];
}

export const useContractBalances = (
  advertiserNation: string,
  advertiserId?: string,
): {
  data?: ContractBalances;
  error?: Error;
  isLoading: boolean;
} => {
  const { data, error, loading, previousData } = useQuery(
    contractBalancesQuery,
    {
      variables: {
        advertiserId: advertiserId!,
        advertiserNation,
      },
      skip: !advertiserId,
    },
  );

  return {
    data: loading && previousData ? previousData : data,
    isLoading: loading,
    error,
  };
};
